var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"song",staticStyle:{"border":"1px solid #ccc"}},[_vm._t("default"),_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.song.name)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.song.author)+" ")])],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }